import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "../components/Layout";
import Dashboard from "../pages/dashboard/Dashboard";
import SystemTickets from "../pages/system-tickets/Tickets";
import TicketDetail from "../pages/system-tickets/TicketDetails";
import SystemManagement from "../pages/system-management/System";

const isAuthenticated = () => {
  return localStorage.getItem("token")
};

const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

const AppRoutes = () => (
  <Layout>
    <Routes>
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tickets/:system"
        element={
          <ProtectedRoute>
            <SystemTickets />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ticket/:id"
        element={
          <ProtectedRoute>
            <TicketDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/system-management"
        element={
          <ProtectedRoute>
            <SystemManagement />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Layout>
);

export default AppRoutes;
